import { DOCUMENT_TEMPLATES_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";
import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { IBaseModel } from "../../shared/interfaces/shared/IBase";
import {
  IDocumentTemplate,
  IDocumentTemplateSection,
} from "../../shared/interfaces/document-template/IDocumentTemplate";

export const DocumentTemplateService = {
  get: (pagination: IPagination): Promise<IBaseModel<IDocumentTemplate[]>> =>
    requests.get(DOCUMENT_TEMPLATES_URL, pagination),
  getSingle: (id: number): Promise<IDocumentTemplate> =>
    requests.get(`${DOCUMENT_TEMPLATES_URL}/${id}`),
  create: (params: Partial<IDocumentTemplate>) =>
    requests.post(DOCUMENT_TEMPLATES_URL, params),
  update: (params: Partial<IDocumentTemplate>, id: number) =>
    requests.put(`${DOCUMENT_TEMPLATES_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${DOCUMENT_TEMPLATES_URL}/${id}`),
  setDefault: (id: number) =>
    requests.patch(`${DOCUMENT_TEMPLATES_URL}/${id}/set-default`),
  getSections: (id: number): Promise<IDocumentTemplateSection[]> =>
    requests.get(`${DOCUMENT_TEMPLATES_URL}/${id}/sections`),
  addSection: (id: number, params: Partial<IDocumentTemplateSection>) =>
    requests.post(`${DOCUMENT_TEMPLATES_URL}/${id}/sections`, params),
  updateSection: (
    id: number,
    sectionId: number,
    params: Partial<IDocumentTemplateSection>
  ) =>
    requests.put(
      `${DOCUMENT_TEMPLATES_URL}/${id}/sections/${sectionId}`,
      params
    ),
  deleteSection: (id: number, sectionId: number) =>
    requests.delete(`${DOCUMENT_TEMPLATES_URL}/${id}/sections/${sectionId}`),
  assignCustomer: (id: number, customerId: number) =>
    requests.post(`${DOCUMENT_TEMPLATES_URL}/${id}/assign`, { customerId }),
  unassignCustomer: (id: number, customerId: number) =>
    requests.delete(`${DOCUMENT_TEMPLATES_URL}/${id}/assign/${customerId}`),
  getAssignedCustomers: (id: number) =>
    requests.get(`${DOCUMENT_TEMPLATES_URL}/${id}/assigned-customers`),
  getVariables: () => requests.get(`${DOCUMENT_TEMPLATES_URL}/variables`),
};
